export default __webpack_public_path__ + "static/media/extended-room.c4280eb1.svg";